import * as yup from 'yup';
import {types} from '../../types';

const firstNameRequired = 'Podaj swoje imię.';
const lastNameRequired = 'Podaj swoje nazwisko.';
const phoneNumberRequired = 'Podaj numer telefonu.';
const invalidEmail = 'Wpisz poprawny adres e-mail.';
const charactersLimit = 'Przekroczono limit 30 znaków.';
const invalidPhoneNumber = 'Wpisz poprawny numer telefonu.';
const schoolChoiceRequired = 'Wybierz szkołę, w której uczysz.';
const programsRequired = 'Wybór programu jest wymagany.';
const subjectRequired = 'Wybór przedmiotu jest wymagany.';
const termsRequired = 'Musisz wyrazić zgodę na przetwarzanie danych.';

export const validationSchema = yup.object().shape({
            firstName: yup.string().required(firstNameRequired).max(30, charactersLimit),
            lastName: yup.string().required(lastNameRequired).max(30, charactersLimit),
            email: yup.string().email(invalidEmail).required(invalidEmail),
            phoneNumber: yup.string()
                .transform((value) => (value === '' ? undefined : value))
                .max(30, charactersLimit)
                .matches(/^[\d]{9}$/g, invalidPhoneNumber)
                .test('phone-call-agreement', phoneNumberRequired, function (value) {
                    const {callAgreement} = this.parent;
                    if (callAgreement && !value) {
                        return this.createError({message: phoneNumberRequired});
                    }
                    return true;
                }),
            schoolId: yup.string().required(schoolChoiceRequired),
            programId: yup.string().nullable().required(programsRequired),
            subjectId: yup.string().required(subjectRequired),
            marketingAgreement: yup
                .bool()
                .isTrue(termsRequired),
            emailAgreement: yup
                .bool()
                .isTrue(termsRequired),
            callAgreement: yup
                .bool()
                .test('call-phone-agreement', termsRequired, function (value) {
                    const {phoneNumber} = this.parent;
                    if (phoneNumber && phoneNumber.trim() !== '' && !value) {
                        return this.createError({message: termsRequired});
                    }
                    return true;
                }),
        }
    )
;

export const defaultValues: types.TParticipant = {
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    schoolId: '',
    programName: '',
    schoolLevel: '',
    programId: '',
    subjectId: '',
    marketingAgreement: false,
    emailAgreement: false,
    callAgreement: false,
};
